import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  SelectTabData,
  SelectTabEvent,
  Tab,
  TabList,
  TabValue,
  makeStyles,
} from '@fluentui/react-components';
import { AddRegular, EditOffRegular, PeopleRegular } from '@fluentui/react-icons';
import { AccessType, TPermissions, useCanEdit } from '@modules/access';
import { TFile, TFileVersion } from '../types';
import CommentsHeaderButton from '@modules/comments/components/CommentsHeaderButton';
import { AiAssistantSidebarButton, useCanUseAiQa } from '@modules/ai';

const useStyles = makeStyles({
  menuButton: {
    '& .fui-MenuButton__menuIcon': {
      fontSize: '15px',
      marginBottom: '6px',
    },
  },
});

type TProps = {
  file: TFile;
  version: TFileVersion;
  selectedTab: TabValue;
  setSelectedTab: (value: TabValue) => void;
  permissions: TPermissions;
  onCreateVersion: () => void;
  handleShowAccess: () => void;
};

const Header = ({
  file,
  version,
  selectedTab,
  setSelectedTab,
  permissions,
  onCreateVersion,
  handleShowAccess,
}: TProps) => {
  const { canEdit } = useCanEdit(permissions.accessRight);
  const canUseAiQa = useCanUseAiQa();

  const onTabSelect = (_: SelectTabEvent, data: SelectTabData) => {
    if (data.value === 'file') return;
    setSelectedTab(data.value);
  };

  const classes = useStyles();

  return (
    <header className="sticky z-40 w-full">
      <div>
        <div className="flex pb-2 justify-between items-end">
          <TabList selectedValue={selectedTab} onTabSelect={onTabSelect} size="small">
            <Tab value="home">Home</Tab>
            <Tab value="history">History</Tab>
            <Tab value="approvals">Approvals</Tab>
          </TabList>

          <div className="flex space-x-2 items-center">
            {canUseAiQa ? (
              <>
                {permissions.accessRight >= AccessType.MANAGE && (
                  <Button appearance="secondary" size="small" icon={<PeopleRegular />} onClick={handleShowAccess}>
                    Access
                  </Button>
                )}
                <CommentsHeaderButton item={file} version={version} />
                <AiAssistantSidebarButton disabledTooltip="Available on documents and folders only." />
              </>
            ) : (
              <>
                <CommentsHeaderButton item={file} version={version} />

                <Menu>
                  <MenuTrigger disableButtonEnhancement>
                    <MenuButton size="small" icon={<EditOffRegular />} className={classes.menuButton}>
                      View mode
                    </MenuButton>
                  </MenuTrigger>
                  <MenuPopover>
                    {canEdit ? (
                      <MenuList>
                        <MenuItem icon={<AddRegular />} onClick={onCreateVersion}>
                          Upload new version
                        </MenuItem>
                      </MenuList>
                    ) : (
                      <p className="p-1">No edit permission</p>
                    )}
                  </MenuPopover>
                </Menu>
                {permissions.accessRight >= AccessType.MANAGE && (
                  <Button appearance="primary" size="small" icon={<PeopleRegular />} onClick={handleShowAccess}>
                    Access
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
